import  axiosClient  from "./../Network/apiClient"

const SeasonService = {

    getYears: () => {
        return axiosClient.get('/seasons');
    }
}

export default SeasonService
